'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, Download, Gavel, ShieldCheck } from 'lucide-react';
interface MolduraDocumentoProps {
  readonly camara: string;
  readonly legendaCamara: string;
  readonly numeroProcesso: string;
  readonly titulo: string;
  readonly subtitulo: string;
  readonly codigoAutenticidade: string;
  readonly icone: 'gavel' | 'shield';
  readonly processoEncerradoEm: string | null;
  readonly assinatura?: string | null;
  readonly onVoltar?: () => void;
  readonly onBaixarPdf?: () => void;
  readonly children: React.ReactNode;
}
export function MolduraDocumento(t0) {
  const $ = _c(57);
  const {
    camara,
    legendaCamara,
    numeroProcesso,
    titulo,
    subtitulo,
    codigoAutenticidade,
    icone,
    processoEncerradoEm,
    assinatura: t1,
    onVoltar,
    onBaixarPdf,
    children
  } = t0;
  const assinatura = t1 === undefined ? null : t1;
  const Icone = icone === "gavel" ? Gavel : ShieldCheck;
  const t2 = !onVoltar;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowLeft aria-hidden="true" className="h-4 w-4" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== onVoltar || $[2] !== t2) {
    t4 = <button className="flex items-center gap-1.5 text-sm text-neutral-700 disabled:opacity-40" disabled={t2} onClick={onVoltar} type="button">{t3}Voltar</button>;
    $[1] = onVoltar;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = !onBaixarPdf;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Download aria-hidden="true" className="h-4 w-4" />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== onBaixarPdf || $[6] !== t5) {
    t7 = <button className="flex items-center gap-1.5 rounded-[8px] border border-neutral-300 px-3 py-1.5 text-sm text-neutral-700 disabled:opacity-40" disabled={t5} onClick={onBaixarPdf} type="button">{t6}Baixar PDF</button>;
    $[5] = onBaixarPdf;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t4 || $[9] !== t7) {
    t8 = <div className="mb-4 flex items-center justify-between">{t4}{t7}</div>;
    $[8] = t4;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== Icone) {
    t9 = <div className="bg-brand-50 text-brand-600 flex h-8 w-8 items-center justify-center rounded-md"><Icone aria-hidden="true" className="h-4.5 w-4.5" /></div>;
    $[11] = Icone;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== camara) {
    t10 = <p className="font-medium text-neutral-900">{camara}</p>;
    $[13] = camara;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== legendaCamara) {
    t11 = <p className="text-neutral-600">{legendaCamara}</p>;
    $[15] = legendaCamara;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <div className="text-xs leading-tight">{t10}{t11}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t9) {
    t13 = <div className="flex items-center gap-2.5">{t9}{t12}</div>;
    $[20] = t12;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <br />;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== numeroProcesso) {
    t15 = <div className="text-right text-xs text-neutral-600">Processo{t14}<span className="font-mono text-neutral-900">{numeroProcesso}</span></div>;
    $[24] = numeroProcesso;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15) {
    t16 = <header className="flex items-center justify-between border-b border-neutral-200 pb-3">{t13}{t15}</header>;
    $[26] = t13;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== processoEncerradoEm) {
    t17 = processoEncerradoEm ? <p className="mt-4 rounded-[8px] bg-neutral-50 p-2.5 text-xs text-neutral-600">Processo encerrado — este documento permanece válido e imutável.</p> : null;
    $[29] = processoEncerradoEm;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== titulo) {
    t18 = <h1 className="mt-5 text-[17px] font-medium text-neutral-900">{titulo}</h1>;
    $[31] = titulo;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== subtitulo) {
    t19 = <p className="mb-5 text-sm text-neutral-600">{subtitulo}</p>;
    $[33] = subtitulo;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== children) {
    t20 = <div className="space-y-4">{children}</div>;
    $[35] = children;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  const t21 = assinatura ?? "Secretaria arbitral";
  let t22;
  let t23;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <br />;
    t23 = <span className="text-neutral-500">Documento assinado eletronicamente</span>;
    $[37] = t22;
    $[38] = t23;
  } else {
    t22 = $[37];
    t23 = $[38];
  }
  let t24;
  if ($[39] !== t21) {
    t24 = <p className="text-xs leading-relaxed text-neutral-600">{t21}{t22}{t23}</p>;
    $[39] = t21;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <br />;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== codigoAutenticidade) {
    t26 = <p className="text-right text-[11px] leading-relaxed text-neutral-500">Autenticidade{t25}<span className="font-mono text-neutral-600">{codigoAutenticidade}</span></p>;
    $[42] = codigoAutenticidade;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] !== t24 || $[45] !== t26) {
    t27 = <footer className="mt-6 flex items-end justify-between border-t border-neutral-200 pt-3">{t24}{t26}</footer>;
    $[44] = t24;
    $[45] = t26;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== t16 || $[48] !== t17 || $[49] !== t18 || $[50] !== t19 || $[51] !== t20 || $[52] !== t27) {
    t28 = <article className="bg-default-background rounded-[16px] border border-solid border-neutral-200 p-8">{t16}{t17}{t18}{t19}{t20}{t27}</article>;
    $[47] = t16;
    $[48] = t17;
    $[49] = t18;
    $[50] = t19;
    $[51] = t20;
    $[52] = t27;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== t28 || $[55] !== t8) {
    t29 = <div className="bg-neutral-50 py-6"><div className="mx-auto w-full max-w-[794px] px-4">{t8}{t28}</div></div>;
    $[54] = t28;
    $[55] = t8;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  return t29;
}